import {ChartDataset} from 'chart.js';

export class ChartUtils {
    public static customizeLineColor(chartData: ChartDataset<'line'>, color: string) {
        this.customizeColor(chartData, color);
        chartData.pointBorderColor = color;
        chartData.pointHoverBorderColor = color;
        chartData.pointBackgroundColor =  color;
        chartData.pointHoverBackgroundColor = color;
    }

    public static customizeColor(chartData: ChartDataset, color: string) {
        chartData.borderColor = color;
        chartData.hoverBorderColor = color;
        chartData.backgroundColor = color;
        chartData.hoverBackgroundColor = color;
    }
}
